interface HeroSectionProps {
  onKampanyaClick: () => void;
  onBilgiAlClick: () => void;
}

export default function HeroSection({ onKampanyaClick, onBilgiAlClick }: HeroSectionProps) {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=luxury%20beauty%20spa%20interior%20with%20soft%20golden%20lighting%2C%20elegant%20white%20marble%20surfaces%2C%20fresh%20flowers%2C%20premium%20skincare%20products%20arranged%20beautifully%2C%20warm%20cream%20and%20gold%20tones%2C%20high-end%20beauty%20clinic%20atmosphere%2C%20soft%20bokeh%20background%2C%20ultra%20clean%20aesthetic%2C%20professional%20photography&width=1920&height=1080&seq=hero001&orientation=landscape"
          alt="Elora Beauty Lounge"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1A0F0A]/80 via-[#1A0F0A]/60 to-[#2D1810]/75" />
      </div>

      {/* Decorative accent line */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#E8B86D] to-transparent" />

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 md:px-10 max-w-5xl mx-auto">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-[#E8B86D]/15 backdrop-blur-sm border border-[#E8B86D]/40 text-[#E8B86D] text-xs font-semibold px-5 py-2 rounded-full mb-8 tracking-[0.2em] uppercase">
          <span className="w-1.5 h-1.5 rounded-full bg-[#E8B86D] inline-block animate-pulse" />
          Premium Güzellik Merkezi
        </div>

        {/* Headline — bold italic dramatic */}
        <h1
          className="font-black italic text-white leading-[0.9] mb-6 tracking-tight"
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: "clamp(3rem, 8vw, 6.5rem)",
          }}
        >
          Kendiniz İçin
          <br />
          <span
            className="not-italic"
            style={{
              background: "linear-gradient(135deg, #E8B86D 0%, #F5D08A 50%, #C9943A 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            En Doğru Bakımı
          </span>
          <br />
          <span className="text-white">Keşfedin</span>
        </h1>

        {/* Sub */}
        <p className="text-lg md:text-xl text-white/75 max-w-2xl mx-auto leading-relaxed mb-10 font-light tracking-wide">
          Cildinize ve görünümünüze özel en etkili uygulamaları sizin için bir araya getirdik
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={onKampanyaClick}
            className="group relative overflow-hidden bg-[#E8B86D] hover:bg-[#D4A45A] text-[#1A0F0A] font-bold px-9 py-4 rounded-full text-base transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            <span className="relative z-10 flex items-center gap-2">
              Kampanyaları İncele
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
            </span>
          </button>
          <button
            onClick={onBilgiAlClick}
            className="bg-transparent hover:bg-white/10 text-white border-2 border-white/30 hover:border-white/60 font-semibold px-9 py-4 rounded-full text-base transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Hemen Bilgi Al
            <i className="ri-phone-line" />
          </button>
        </div>

        {/* Stats */}
        <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-16">
          {[
            { value: "5.000+", label: "Mutlu Müşteri" },
            { value: "12 Yıl", label: "Deneyim" },
            { value: "98%", label: "Memnuniyet" },
          ].map((stat, i) => (
            <div key={stat.label} className="text-center relative">
              {i > 0 && (
                <div className="hidden sm:block absolute -left-8 top-1/2 -translate-y-1/2 w-px h-8 bg-white/20" />
              )}
              <div
                className="text-3xl md:text-4xl font-black italic"
                style={{
                  fontFamily: "'Playfair Display', serif",
                  background: "linear-gradient(135deg, #E8B86D, #F5D08A)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                {stat.value}
              </div>
              <div className="text-white/55 text-xs mt-1 tracking-widest uppercase font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40 animate-bounce">
        <span className="text-xs tracking-[0.2em] uppercase font-medium">Keşfet</span>
        <i className="ri-arrow-down-line text-lg" />
      </div>
    </section>
  );
}